import { render, staticRenderFns } from "./LegislacaoSelecionada.vue?vue&type=template&id=91499a24"
import script from "./LegislacaoSelecionada.vue?vue&type=script&lang=ts&setup=true"
export * from "./LegislacaoSelecionada.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports